export const types = {
  CREATE_CATALOGUE:"CREATE_CATALOGUE",
  CREATE_CATALOGUE_SUCCESS:"CREATE_CATALOGUE_SUCCESS",
  GET_CATALOGUE:"GET_CATALOGUE",
  GET_CATALOGUE_SUCCESS:"GET_CATALOGUE_SUCCESS",
  UPDATE_CATALOGUE:"UPDATE_CATALOGUE",
  UPDATE_CATALOGUE_SUCCESS:"UPDATE_CATALOGUE_SUCCESS",
  DELETE_CATALOGUE:"DELETE_CATALOGUE",
  DELETE_CATALOGUE_SUCCESS: "DELETE_CATALOGUE_SUCCESS",
  ADD_PRODUCT_WITH_CATALOGUE_ID: "ADD_PRODUCT_WITH_CATALOGUE_ID",
  ADD_PRODUCT_WITH_CATALOGUE_ID_SUCCESS: "ADD_PRODUCT_WITH_CATALOGUE_ID_SUCCESS",
  GET_ALL_PRODUCT_WITH_CATALOGUE_ID: "GET_ALL_PRODUCT_WITH_CATALOGUE_ID",
  GET_ALL_PRODUCT_WITH_CATALOGUE_ID_SUCCESS: "GET_ALL_PRODUCT_WITH_CATALOGUE_ID_SUCCESS",
  REMOVE_PRODUCT_FROM_CATALOGUE: "REMOVE_PRODUCT_FROM_CATALOGUE",
  REMOVE_PRODUCT_FROM_CATALOGUE_SUCCESS:"REMOVE_PRODUCT_FROM_CATALOGUE_SUCCESS"
}